import React, { Component } from 'react';
import { Grid, Card, Dropdown, Pagination } from 'semantic-ui-react';
import Loading from '../loading';
import $ from "jquery";
import Server from '../../functions/server';
import View from './view';
import ReadCookie from '../../functions/readcookies';

class Menucontrol extends Component {

  state = {
    data: [],
    load: false,
    pageNumber: 0,
    totalPages: 50,
    boundaryRange: 1,
    serialNumber: 0,
    siblingRange: 1,
  }

  componentDidUpdate(props) {
    if (props.value != this.props.value) {
      this.getMenuControl(1, this.props.value)
    }
  }

  componentDidMount() {
    this.getMenuControl(1, this.props.value)
  }

  getProcessedMenuData(data) {
    console.log(data);
    let x = [];
    data.map((temp) => {
      let b = true;
      for (var i = 0; i < x.length; i++) {
        if (x[i].name == temp.name && x[i].menu == temp.menu) {
          x[i].type_name.push({type: temp.type, type_name: temp.type_name, id: temp.id});
          x[i].ids.push(temp.id);
          b = false;
        }
      }
      if (b) {
        let type_name = {type: temp.type, type_name: temp.type_name, id: temp.id};
        let id = temp.id;
        temp.type_name = [];
        temp.type_name.push(type_name);
        temp.ids = [];
        temp.ids.push(id);
        x.push(temp);
        console.log(x);
      }
    });
    return x;
  }

  handlePaginationChange = (e, { activePage }) => {
    this.getMenuControl(activePage, this.props.value);
  }

  getMenuControl(page, value) {
    let context = this;
    value = value.split('->')[0];
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let data1 = {'executiveId': value, 'userId': userId };
    context.setState({
      load: true,
      message: 'Getting menu controller!!!',
      menucontrol: false
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/getexecutivemenucontrol.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          data = context.getProcessedMenuData(data);
          context.setState({ data: data })
        } catch (e) {
          alert('Error!!!');
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    })
  }

  updatedata(data) {
    this.setState({
      data: data
    });
  }

  appendsdata() {
    this.getMenuControl(1, this.props.value);
  }

  render() {
    let view = (<div></div>);
    if (this.state.data) {
      view = (<View data={this.state.data}
        serialNumber={this.state.serialNumber}
        
        updatedata={this.updatedata.bind(this)}
        value={this.props.value} menuPermission={this.props.menuPermission} />);
    }
    else {

    }
    let { load, message} = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div style={{paddingTop: '2%'}}>
        {view}
        {loading}
      </div>
    );
  }
}

export default Menucontrol;
